import Immutable from 'immutable';

export const LOAD = 'insight/LOAD';
export const LOAD_SUCCESS = 'insight/LOAD_SUCCESS';
export const LOAD_FAIL = 'insight/LOAD_FAIL';

const ACCOUNTSTATS = 'insight/ACCOUNTSTATS';
const ACCOUNTSTATS_SUCCESS = 'insight/ACCOUNTSTATS_SUCCESS';

const VIDEOS = 'insight/VIDEOS';
const VIDEOS_SUCCESS = 'insight/VIDEOS_SUCCESS';

export const CAMPAIGN = 'insight/CAMPAIGN';
export const CAMPAIGN_SUCCESS = 'insight/CAMPAIGN_SUCCESS';

const VIDEOVIEWSANDPLAYS = 'insight/VIDEOVIEWSANDPLAYS';
const VIDEOVIEWSANDPLAYS_SUCCESS = 'insight/VIDEOVIEWSANDPLAYS_SUCCESS';

const initialState = Immutable.fromJS({
  Insights: [],
  loading: false,
  errorMessage: null,
  accountStats: [],
  videos: [],
  campaigns: [],
  videoViewsAndPlays: {}
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('loading', true)

    case LOAD_FAIL:
      return state
        .set('loading', false)
        .set('errorMessage', action.errorMessage);

    case LOAD_SUCCESS:
      return state
        .set('loading', false)
        .set('Insights', action.Insights);

    case ACCOUNTSTATS:
      return state
        .set('loading', true);

    case ACCOUNTSTATS_SUCCESS:
      return state
        .set('loading', false)
        .set('accountStats', action.accountStats);

    case VIDEOS:
      return state
        .set('loading', true);

    case VIDEOS_SUCCESS:
      return state
        .set('loading', false)
        .set('videos', action.videos);

    case CAMPAIGN:
      return state
        .set('loading', true);

    case CAMPAIGN_SUCCESS:
      return state
        .set('loading', false)
        .set('campaigns', action.campaigns);

    case VIDEOVIEWSANDPLAYS:
      return state
        .set('loading', true);

    case VIDEOVIEWSANDPLAYS_SUCCESS:
      return state
        .set('loading', false)
        .set('videoViewsAndPlays', action.videoViewsAndPlays);

    default:
      return state;
  }
}

export const getInsights = ( ) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });

  try {
    const res = await api.get('/insights');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LOAD_SUCCESS,  Insights: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const accountStats = () => async (dispatch, getState, api) => {
  dispatch({ type: ACCOUNTSTATS });
  try {
    const res = await api.get('/insights/accountStats');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: ACCOUNTSTATS_SUCCESS, accountStats: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getVideoStats = (pageNum, column, direction) => async (dispatch, getState, api) => {
  dispatch({ type: VIDEOS });
  try {
    const res = await api.get('/insights/videoStats', { params: { pageNum, column, direction }});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: VIDEOS_SUCCESS, videos: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getCampaignStats = (pageNum, column, direction) => async (dispatch, getState, api) => {
  dispatch({ type: CAMPAIGN });
  try {
    const res = await api.get('/insights/campaignStats', {params: { pageNum, column, direction }});
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: CAMPAIGN_SUCCESS, campaigns: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getVideosByMonth = (data) => async (dispatch, getState, api) => {
  dispatch({ type: CAMPAIGN });
  try {
    const res = await api.put('/insights/perMonthVideos', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getVideosViewsAndPlaysCount = () => async (dispatch, getState, api) => {
  dispatch({ type: CAMPAIGN });
  try {
    const res = await api.get('/insights/getVideosViewsAndPlaysCount');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: VIDEOVIEWSANDPLAYS_SUCCESS, videoViewsAndPlays: res });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};




// WEBPACK FOOTER //
// ./src/redux/modules/insight.js